let cachedTabId: string | null = null;

export function getTabId(): string {
  if (cachedTabId) return cachedTabId;

  // Genera un ID único solo para esta instancia de ejecución
  cachedTabId = `${crypto.randomUUID()}-${Math.floor(Math.random() * 10000)}`;

  return cachedTabId;
}


export function calcularDistancia(coord1: { lat: number; lng: number; }, coord2: { lat: number; lng: number; }): number {
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = (coord2.lat - coord1.lat) * (Math.PI / 180);
  const dLng = (coord2.lng - coord1.lng) * (Math.PI / 180);
  const a = 
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(coord1.lat * (Math.PI / 180)) * Math.cos(coord2.lat * (Math.PI / 180)) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in kilometers
}

export function base64ToBlob(base64: string, contentType = 'image/png'): Blob {
  const parts = base64.split(',');
  if (parts.length !== 2 || !parts[0].startsWith('data:image')) {
    throw new Error('Formato base64 inválido.');
  }

  const byteString = atob(parts[1]);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  return new Blob([uint8Array], { type: contentType });
}
